"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const svgs_1 = require("@@/assets/svgs");
const Button_1 = __importDefault(require("@mui/material/Button"));
const _1 = require(".");
function default_1() {
    const [openGuide, setOpenGuide] = (0, react_1.useState)(false);
    const closeGuide = () => setOpenGuide(false);
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(Button_1.default, Object.assign({ onClick: () => setOpenGuide(true), fullWidth: true, sx: {
                    justifyContent: 'space-between',
                    p: '12px 16px',
                    borderRadius: '8px',
                    color: 'var(--blue-50)',
                    bgcolor: 'var(--table-row) !important',
                } }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "subtitle4 gray-80", css: { display: 'flex', alignItems: 'center', columnGap: '8px' } }, { children: [(0, jsx_runtime_1.jsx)(svgs_1.QuestionIconBlueSvg, {}), t('한 번에 정산 받는 법')] })), (0, jsx_runtime_1.jsx)(svgs_1.ChevronDownSvg, { css: { width: '20px', height: '20px' } })] })), (0, jsx_runtime_1.jsx)(_1.SettlementGuideDialog, { open: openGuide, closeDialog: closeGuide })] }));
}
exports.default = default_1;
